import { createContext, defaultValue, useContext, useEffect } from 'react';
import { useAppManager } from 'core/hooks';

export { useAppManager };

const RootStoresContext = createContext(defaultValue);

export const useRootStores = () => useContext(RootStoresContext);
export const RootStoresProvider = RootStoresContext.Provider;

export const useRouterStore = () =>
  useContext(RootStoresContext).stores.routerStore;
export const useClientStore = () =>
  useContext(RootStoresContext).stores.clientStore;
export const useHeaderStore = () =>
  useContext(RootStoresContext).stores.headerStore;
export const useFrameStore = () =>
  useContext(RootStoresContext).stores.frameStore;
export const useConversionsStore = () =>
  useContext(RootStoresContext).stores.conversionsStore;

export const useNoAuthRedirect = () => {
  const clientStore = useClientStore();
  const routerStore = useRouterStore();
  useEffect(() => {
    if (!clientStore.signedInProfile) {
      routerStore.router.navigate('home.signIn', {
        next: clientStore.next(),
      });
    }
  }, []);
};
